//NG+
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Compiler, ComponentFactoryResolver, Inject, Injectable, Injector } from "@angular/core";
import { LoginComponent } from "./auth-components/login.component";
import { UserMainComponent } from "./auth-components/user-main.component";
import { authAs, authType } from "../definitions";
import { MapController } from "../map/map-controller";
import { LoginComponentB } from "./auth-components/login-b.component";

export interface IAuthDialogsServiceNg {
    showLoginDialog(mapCtrl: MapController): any;
    showRegisterDialog(mapCtrl: MapController): any;
    isLoginDialogOpen(): boolean;
}

@Injectable({
    providedIn: 'root',
  })
export class AuthDialogsServiceNg implements IAuthDialogsServiceNg {
    public LoginDialog: any = null;
    //
    public constructor (
    @Inject(NgbModal) private modalService,
    @Inject(ComponentFactoryResolver) private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(Compiler) private compiler: Compiler,
    @Inject(Injector) private injector: Injector) {
        //
    }
    //
    public showLoginDialog(mapCtrl: MapController){
        let loginComponent = 'default';
        if (mapCtrl && mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_login_custom_b, authType.object)) {
            loginComponent = 'custom-b';
        }
        let windowClass = 'modalLoginMain';
        if (mapCtrl && mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_login_opaque_background, authType.object)) {
            windowClass = 'modalLoginMainOpaque';
        }
        //control_login_opaque_background
        if (loginComponent == 'default'){
            const modalOpt = {backdrop: false,windowClass: windowClass, container: "#map-body-container" }
            this.LoginDialog = this.modalService.open(LoginComponent, modalOpt);
            return this.LoginDialog.result;
        } else if (loginComponent == 'custom-b'){
            const modalOpt = {backdrop: false,windowClass: "modalLoginMainCustomB" }
            this.LoginDialog = this.modalService.open(LoginComponentB, modalOpt);
            return this.LoginDialog.result;
        }
    }
    //
    public showRegisterDialog( mapCtrl: MapController) {
        let windowClass = 'modalSettingsMain';
        if (mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_settings_open_to_right, authType.object)) {
            windowClass = 'modalSettingsMainOpenRight';
        }
        const modalOpt = { backdrop: false, windowClass: windowClass, fullscreen: true , container:"#map-body-container"}
        return import('./auth-components/user-main.module')
            .then((result) => {
                const modalRef = this.modalService.open(UserMainComponent, modalOpt);
                return modalRef.result;
            })
    }
    //
    public isLoginDialogOpen(): boolean {
        let isOpen = false;
        if (this.LoginDialog) {
            isOpen = true;
        }
        return isOpen;
    }
}